import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Spin, ConfigProvider } from 'antd';
import './index.css';
import TopContainer from './layouts/topContainer/index';
import zhCN from 'antd/es/locale/zh_CN';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import Store from './store/store'
// import { HashRouter } from 'react-router-dom'
let _store = createStore(Store);//定义store
ReactDOM.render(
    <Provider store={_store}>
        <ConfigProvider locale={zhCN}><Suspense fallback={<Spin size="large" />}><TopContainer /></Suspense></ConfigProvider>
    </Provider>
    , document.getElementById('root'),
    // <HashRouter >
    // <App />
    // </HashRouter >
    );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
